export const FORCED_DARK_MODE_PAGES = ['/black-friday', '/minha-black-friday'];

export const isDarkModeForcedPage = (pathname) =>
  FORCED_DARK_MODE_PAGES.some((path) => pathname.includes(path));
